import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionListComponent } from './components/session-list/session-list.component';
import { SessionRoutingModule } from './session-routing.module';
import { SessionLeftPanelComponent } from './components/session-left-panel/session-left-panel.component';
import { SessionMainPanelComponent } from './components/session-main-panel/session-main-panel.component';
import { AppRoutingModule } from '../../app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AngularMaterialModule } from '../../shared/material-module';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ResizableModule } from '../../core/directive/resizable/resizable.module';
import { GoogleChartsModule } from 'angular-google-charts';
import { SessionProcessesComponent } from './components/session-processes/session-processes.component';
import { ActionConfirmComponent } from './components/action-confirm/action-confirm.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ClientSessionComponent } from './components/client-session/client-session.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [
    SessionListComponent,
 
    SessionLeftPanelComponent,
    SessionMainPanelComponent,
    SessionProcessesComponent,
    ActionConfirmComponent,
    ClientSessionComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    SessionRoutingModule,
    BrowserModule,
    FormsModule,
    CoreModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    NgxPaginationModule,
    NgxSpinnerModule,
    ResizableModule,
    GoogleChartsModule,
    NgbModule,
    SharedModule
  ]
})
export class SessionModule { }
